import AbstractBanner from '../../components/UtilityBanners/AbstractBanner/AbstractBanner';
import { markBannerAsRead, markBannerCTAClicked } from './utils';
import { useMemo, useState } from 'react';
import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { config, secureDocument } from 'sanitize-text/sanitizers/SanitizeConfiguration';
import Raven from 'raven-js';
import I18n from 'I18n';
import { BANNER_TYPES } from '../../components/UtilityBanners/AbstractBanner/AbstractBannerComponents';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BannerNotification = ({
  notification
}) => {
  const {
    id,
    ctaProxyUrl,
    translatedTemplate: {
      subject,
      ctaText,
      body
    }
  } = notification;
  const [ctaDisabled, setCtaDisabled] = useState(false);
  const handleClose = () => {
    markBannerAsRead(notification).catch(e => {
      Raven.captureException(e);
    });
  };
  const handleCTAClick = () => {
    setCtaDisabled(true);
    markBannerCTAClicked(notification).catch(e => {
      Raven.captureException(e);
    });
  };
  const ctaDisplayText = ctaText || I18n.text('bannerNotification.button.mainCtaText');
  const bannerId = `banner-notification-${id}`;
  const {
    attributes,
    add_attributes,
    protocols
  } = config.HTML;
  let sanitizedBody = sanitize(body, {
    dom: secureDocument,
    elements: ['a', 'br', 'span', 'strong'],
    attributes: {
      a: attributes.a,
      span: ['style']
    },
    add_attributes: add_attributes.a,
    protocols: protocols.a
  });
  const bodyOnNewLine = sanitizedBody.startsWith('<br>');
  sanitizedBody = bodyOnNewLine ? sanitizedBody.replace('<br>', '') : sanitizedBody;
  const bannerType = useMemo(() => {
    var _notification$context;
    const priority = (_notification$context = notification.context.find(c => c.key === 'bannerPriority')) === null || _notification$context === void 0 ? void 0 : _notification$context.value;
    switch (priority) {
      case 'HIGH':
        return BANNER_TYPES.DANGER;
      case 'LOW':
        return BANNER_TYPES.INFO;
      default:
        return BANNER_TYPES.WARNING;
    }
  }, [notification]);
  return /*#__PURE__*/_jsxs(AbstractBanner, {
    isCloseable: true,
    onClose: handleClose,
    storageKey: bannerId,
    title: subject,
    type: bannerType,
    "data-test-id": "banner-notification",
    setLocalStorage: false,
    fullWidthTitle: bodyOnNewLine,
    children: [/*#__PURE__*/_jsx(Flex, {
      flex: '1 1 auto',
      alignItems: "center",
      flexWrap: "wrap",
      children: /*#__PURE__*/_jsx(TFlex, {
        align: "center",
        marginInlineEnd: "300",
        wrap: "wrap",
        dangerouslySetInnerHTML: {
          __html: sanitizedBody
        }
      })
    }), /*#__PURE__*/_jsx(Button, {
      "data-selenium": "ctaButton",
      "data-test-id": "notification-banner-cta-button",
      onClick: handleCTAClick,
      disabled: ctaDisabled,
      href: ctaProxyUrl,
      use: "tertiary",
      size: "sm",
      children: ctaDisplayText
    })]
  }, bannerId);
};